import { css } from '@emotion/react';
import { Box, styled } from '@mui/material';

export const HeaderWrapper = styled(Box)(
  ({ theme }) => css`
    background-color: ${theme.palette.common.white};
  `,
);
